import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { responsiveImageType } from '../../propTypes';
import { expandAbsolutely } from '../../styles/theme';
import ImageOrVideo from '../ImageOrVideo';

const OverlayImage = ({ classes, image }) => (
  image ? (
    <ImageOrVideo
      className={classes.overlay}
      imageClassName={classes.overlayImage}
      image={image}
    />
  ) : null
);

OverlayImage.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  image: responsiveImageType,
};

OverlayImage.defaultProps = {
  image: null,
};

export default injectSheet({
  overlay: {
    ...expandAbsolutely,
    pointerEvents: 'none',
  },
  overlayImage: {
    height: '100%',
    '& img': {
      objectFit: 'contain',
      fontFamily: '"object-fit: contain;"', // object-fit polyfill
    },
  },
})(OverlayImage);
